import { Box } from '@mui/material';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import { router } from './routes/routes';
import { DefaultToastConfig } from './utils/defaultToastConfig';

function App() {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          backgroundColor: '#fff',
          minHeight: { sm: '100vh' },
          maxWidth: '1200px',
          mx: 'auto',
        }}
      >
        <RouterProvider router={router} />
        <ToastContainer {...DefaultToastConfig} />
      </Box>
    </>
  );
}

export default App;
